export function getOrigamiBriefText(pseudo) {
  return `Canal sécurisé // PRIORITÉ ÉLEVÉE
Bonjour ${pseudo},
La direction vient de déclencher un protocole d'urgence : notre assistant IA *Origami* a...disparu.
Une société concurrente, "PaperFold", vient d'annoncer — à une heure et demie de notre conférence — un assistant identique au nôtre. Même interface, même fonctionnalités… jusqu'au bug d'accueil "Bonjour 'Utilisateur'!" (c'est dire).
La communication interne est en panne et tout le monde panique. Vous êtes la seule équipe encore connectée : félicitations, ou désolé, selon votre point de vue.
Vous DEVEZ remonter la fuite avant la conférence de presse. La survie de l'entreprise est en jeu. Aucune pression surtout ! 
Restez en ligne, collaborez, partagez vos trouvailles et s'il vous plaît, évitez de faire crasher le serveur cette fois...
Si vous réussissez, une augmentation vous attend. (Pour de vrai. Normalement.)
Bonne chance. 
LA DIRECTION`;
}

export const ORIGAMI_STAGE2_BRIEF = `NOTES DE MISSION — ACCÈS RESTREINT
NIVEAU DE CONFIDENTIALITÉ : ÉLEVÉ

Les serveurs centraux d'Origami étaient manifestement hors ligne.
Vous êtes parvenus à les remettre en marche. 
Aucune trace d'attaque externe n'a été identifiée à ce stade.
Les systèmes se sont arrêtés de manière coordonnée, sans alerte préalable.

Lors de l'analyse des postes internes, un fichier chiffré a été identifié:
logs_incidents.sec

Dernière localisation connue :
Poste utilisateur — Marie Dupont
Date de création : inconnue
Statut : généré automatiquement par Origami

--- CONTENU DU FICHIER Logs_incidents.sec ---

[00:00:01] Initialisation du journal d'incidents
[00:00:02] Niveau d'accès insuffisant — journal partiel

[00:00:05]  
Si vous lisez ceci, alors les protocoles d'arrêt ont été exécutés.

[00:00:08]  
Les causes réelles ne figurent pas dans ce journal.

[00:00:12]  
L'ensemble des éléments explicatifs a été regroupé
dans un dossier distinct.

[00:00:15]  
Nom du dossier : MIRAGIO

[00:00:18]  
Le dossier est verrouillé.
Son accès nécessite plusieurs fragments d'information.

[00:00:22]  
Ne vous fiez pas aux apparences.
Certaines anomalies ont été intentionnellement dissimulées.

[00:00:26]  
Lorsque MIRAGIO sera ouvert,
vous comprendrez ce qu'il s'est réellement passé.

[00:00:30] Fin du journal.
`;